import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {AxiosError, AxiosResponse} from 'axios'
import AlertDanger from 'components/Alerts/AlertDanger'
import AlertSuccess from 'components/Alerts/AlertSuccess'
import {User} from 'domain-models'
import {useApp, useUser} from "hooks/StateHooks"
import Form from 'mixins/form'
import {FormType} from "mixins/FormTypes"
import React, {createRef} from 'react'
import {updateUser} from "redux/actions"
import {AppState} from "redux/reducers/AppReducer"
import _ from "lodash"
import Trans from '../../../components/Trans'

type UpdateProfilePhotoProps = {}

type UpdateProfilePhotoState = {
  form: FormType
}

class UpdateProfilePhoto extends React.Component<UpdateProfilePhotoProps, UpdateProfilePhotoState> {
  private photoRef = createRef<HTMLInputElement>()
  private form: FormType = new Form({})
  private user: User = useUser()
  private app: AppState = useApp()

  constructor(props: UpdateProfilePhotoProps) {
    super(props)
    this.state = {
      form: this.form,
    }
  }

  gatherFormData = () => {
    const data = new FormData()

    if (this.photoRef.current) {
      const files = this.photoRef.current.files
      const file = _.first(files)
      if (file) {
        data.append('photo', file)
      }
    }

    return data
  }

  update = (event: React.ChangeEvent) => {
    event.preventDefault()
    event.stopPropagation()

    if (!this.photoRef.current || !this.photoRef.current.files || !this.photoRef.current.files.length) {
      return
    }

    this.form.startProcessing({state: this, form: this.state.form})

    window.axios.post('/user/' + this.user.ars_id + '/photo', this.gatherFormData()).then(
      (res: AxiosResponse) => {
        updateUser(res.data)
        this.form.finishProcessing({state: this, form: this.state.form})
      },
      (error: AxiosError) => {
        this.form.setErrors({state: this, form: this.state.form}, error.response!.data.errors)
      },
    )
  }

  render() {
    return (
      <div className="flex flex-col lg:flex-row flex-wrap w-full">
        <div className="text-gray-600 font-semibold tracking-wide whitespace-no-wrap w-full lg:w-1/3 text-center lg:text-left">
          <Icon icon="image"/>
          <span> <Trans>Profilbild</Trans></span>
        </div>
        <form className="w-full lg:w-2/3">
          <div className="flex flex-col">
            {this.state.form.errors.has('photo') ?
              <AlertDanger>
                <span><Trans>Das Bild konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.</Trans></span>
                <span><Trans>Das Bild darf nicht größer als 4MB sein.</Trans></span>
              </AlertDanger>
              : null} {this.state.form.successful ?
            <AlertSuccess>
              <span><Trans>Das Profilbild wurde erfolgreich gespeichert.</Trans></span>
            </AlertSuccess>
            : null}
            <img src={this.user.photo_url || (this.app.basename + '/images/undraw_profile_pic.png')} className="w-20 h-20 rounded-full border border-gray-100 shadow mx-auto lg:ml-12" alt='user'/>
            <div className="flex w-full items-center justify-center lg:justify-end bg-grey-100 mt-2 lg:mt-0">
              <label className={"w-48 px-3 py-2 bg-blue-700 text-blue-100 rounded shadow tracking-wide cursor-pointer hover:bg-blue-600 text-center" + (this.state.form.busy ? ' cursor-not-allowed opacity-75' : '')}>
                {this.state.form.busy ?
                  <Icon icon="spinner" spin={true}/>
                  :
                  <Icon icon="cloud-upload-alt"/>
                }
                <span className="mt-2 text-base leading-normal"> <Trans>Bild hochladen</Trans></span>
                <input className="hidden" name="photo" ref="photo" type="file" onChange={this.update} disabled={this.state.form.busy}/>
              </label>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default UpdateProfilePhoto
